import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Image, Link, ListLabel, SuffixImage } from './styled';

const MenuItem = ({
  href,
  img,
  isFooter,
  label,
  suffix,
  topBorder,
  active,
  theme = 'menu_item',
  icon,
  clickable,
  onClick,
}) => {
  return (
    <Wrapper
      topBorder={topBorder}
      active={active}
      onClick={clickable ? onClick : undefined}
      isFooter={isFooter}
    >
      <Link as={clickable && 'p'} to={href} onClick={!clickable ? onClick : undefined}>
        {img && <Image src={img} />}
        {icon && icon}
        <ListLabel theme={theme}>{label}</ListLabel>
        {suffix && <SuffixImage src={suffix} alt={label} />}
      </Link>
    </Wrapper>
  );
};

MenuItem.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string,
  theme: PropTypes.oneOf(['menu_item', 'primary_item']),
  img: PropTypes.any,
  suffix: PropTypes.any,
  topBorder: PropTypes.bool,
  active: PropTypes.bool,
};

export default MenuItem;
